import {
  Component,
  Input,
  OnChanges,
  Output,
  EventEmitter,
  OnInit,
  SimpleChanges,
  ChangeDetectionStrategy
} from "@angular/core";
import { FormGroup, FormArray, AbstractControl, UntypedFormArray } from "@angular/forms";
import { Verb } from "@onsip/common/interfaces/verb";
import { PageItem } from "../page-picker.component";
import { GenericSimpleChange } from "@onsip/common/interfaces/generic-simple-change";

type PageType = "rule" | "exception";

interface PageRulePickerSimpleChanges extends SimpleChanges {
  type: GenericSimpleChange<PageType>;
  verbs: GenericSimpleChange<Array<Verb>>;
  initialValues: GenericSimpleChange<Array<PageItem>>;
}

@Component({
  selector: "onsip-page-rule-picker",
  templateUrl: "./page-rule-picker.component.html",
  styleUrls: ["../../topic-write-form.component.scss"],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false
})
export class PageRulePickerComponent implements OnChanges, OnInit {
  @Input() type: PageType = "rule";
  @Input() verbs: Array<Verb> = [];
  @Input() initialValues: Array<PageItem> = [];
  @Output() pageRuleFormInit: EventEmitter<FormArray> = new EventEmitter<FormArray>();

  /** internal form group of form groups where each sub formgroup is indexed and represents a page rule/exception */
  pageRuleFormArray = new UntypedFormArray([]);
  /** Array of information for a page rule or exception. Initially is the initialValues array until the user adds or deletes pages */
  pages: Array<PageItem> = [];

  ngOnInit() {
    this.pageRuleFormInit.emit(this.pageRuleFormArray);
  }

  ngOnChanges(changes: PageRulePickerSimpleChanges) {
    if (this.pageRuleFormArray) {
      if (changes.initialValues && changes.initialValues.currentValue) {
        this.pages = this.initialValues;
        this.pages.forEach((value: PageItem) => {
          const pageFormGroup: AbstractControl | undefined = this.pageRuleFormArray.controls.find(
            (control: AbstractControl) => {
              if (control instanceof FormGroup) {
                return (
                  control.controls.verb.value === value[0] &&
                  control.controls.url.value === value[1]
                );
              }
              return false;
            }
          );
          if (pageFormGroup && pageFormGroup instanceof FormGroup) {
            pageFormGroup.controls.verb.setValue(value[0]);
            pageFormGroup.controls.url.setValue(value[1]);
          }
        });
      }
    }
  }

  onAddPage() {
    this.pages.push([this.verbs[0], ""]);
  }

  onUrlFormInit(urlFormGroup: FormGroup, index: number): void {
    if (!this.pageRuleFormArray.controls[index]) this.pageRuleFormArray.push(urlFormGroup);
  }

  onDeletePage(i: number) {
    this.pageRuleFormArray.removeAt(i);
    this.pages.splice(i, 1);
  }
}
